import type { ReactNode } from 'react';

import { TableCell, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';

interface DataTableGroupRowProps {
  colSpan: number;
  className?: string;
  children: ReactNode;
}

/**
 * A full-width row between data rows — a group header, or a block that belongs
 * to a group rather than to one of its rows. Shared by the flat and the
 * hierarchical body; `className` (from `rowClassName`) overrides the default look.
 */
export function DataTableGroupRow({ colSpan, className, children }: DataTableGroupRowProps) {
  return (
    <TableRow className={cn('bg-muted/30 hover:bg-muted/50 font-medium', className)}>
      <TableCell colSpan={colSpan} className="py-2 px-3 whitespace-normal">
        {children}
      </TableCell>
    </TableRow>
  );
}
